module.exports = __webpack_public_path__ + "static/media/PDF12.5af51292.pdf";